var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26.34 26.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;clip-rule:evenodd;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#1d3152;}.cls-4{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.64,5.44c.22.16.47.31.69.5a7,7,0,0,1,1.46,1.61A3.72,3.72,0,0,1,11.34,10a2.83,2.83,0,0,1-.83,1.7l-3,3-.8.8a2.92,2.92,0,0,1-2.22.83,3.87,3.87,0,0,1-2.42-1A7.39,7.39,0,0,1,.74,14,3.8,3.8,0,0,1,0,11.31,2.76,2.76,0,0,1,.82,9.66L4.6,5.88l.06,0c0,.18-.07.36-.09.54A3.9,3.9,0,0,0,4.9,8.42a.17.17,0,0,1,0,.2L2.38,11.08a.94.94,0,0,0-.26.79A1.85,1.85,0,0,0,2.61,13a8.13,8.13,0,0,0,.84.82,1.74,1.74,0,0,0,1.13.44.89.89,0,0,0,.68-.28L9,10.19a.93.93,0,0,0,.23-.9,2,2,0,0,0-.53-1c-.28-.28-.58-.55-.86-.82h0c-.33-.18-.33-.49-.3-.8a.42.42,0,0,1,.13-.22l.93-.94.06,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.72,10.88a3.5,3.5,0,0,1-.78-.54A7.84,7.84,0,0,1,5.72,9.05,3.89,3.89,0,0,1,5,6.58a2.8,2.8,0,0,1,.82-1.89L8.72,1.76,9.63.85A2.89,2.89,0,0,1,11.69,0,3.79,3.79,0,0,1,14,.75a6.47,6.47,0,0,1,1.68,1.74A3.72,3.72,0,0,1,16.31,5a2.9,2.9,0,0,1-.84,1.7l-3.33,3.33-.45.47c0-.3.08-.57.09-.85a3.83,3.83,0,0,0-.33-1.74.18.18,0,0,1,0-.23L14,5.25a.9.9,0,0,0,.26-.8,2,2,0,0,0-.62-1.23c-.23-.23-.46-.46-.7-.67a1.74,1.74,0,0,0-1-.43.91.91,0,0,0-.78.26C9.84,3.64,8.58,4.89,7.33,6.14a.87.87,0,0,0-.24.75A2,2,0,0,0,7.67,8.1c.28.28.57.54.87.8.09.08.19.13.23.27a1,1,0,0,1,0,.56.27.27,0,0,1-.06.12l-1,1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 5.44,
    width: 21.37,
    height: 20.89
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.97,
    width: 21.37,
    height: 20.88
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlue);
export default __webpack_public_path__ + "static/media/link_blue.7e7b7e9c174a33f913b25547b99fb2b9.svg";
export { ForwardRef as ReactComponent };